import React from "react";
import styles from './index.less';

const Loading = () => {
  return (
    <div className={styles['chaseWrapperWarp']}>
      <div className={styles['chase-wrapper']}>
        <div className={styles['chase-item']}></div>
        <div className={styles['chase-item']}></div>
        <div className={styles['chase-item']}></div>
        <div className={styles['chase-item']}></div>
        <div className={styles['chase-item']}></div>
        <div className={styles['chase-item']}></div>
      </div>
    </div>
  )

}

export default Loading;